<app-loading-spinner *ngIf="couponCheckLoading"></app-loading-spinner>
<!-- Bootstrap danger box if email not verified -->
<div *ngIf="!emailVerified && !couponCheckLoading">
  <div class="container profilo">
    <div
      class="d-flex flex-sm-row flex-column-reverse justify-content-between align-items-center my-5"
    >
      <!-- <div>
        <button
          class="do3-secondary-btn lightBlue w-auto d-flex align-items-center cust"
          (click)="toPrenotazione()"
        >
          <span class="material-icons-outlined">add</span>
          NUOVO VIDEOCONSULTO
        </button>
      </div> -->
      <app-user-info [fetchMe]="true" [size]="'medium'"></app-user-info>
    </div>

    <div class="text-center">
      <mat-icon class="warning">warning</mat-icon>
    </div>
    <div class="d-flex justify-content-center">
      <h1 class="text-center my-4">
        <strong>
          La tua email non è stata ancora verificata. <br />
          Per favore controlla la tua casella di posta elettronica.
        </strong>
      </h1>
    </div>
    <div class="d-flex justify-content-center">
      <!-- Resend email button -->
      <button
        class="btn btn-link p-0"
        (click)="resendVerificationEmail()"
        *ngIf="!emailSent"
      >
        Invia di nuovo email di verifica
      </button>
      <p *ngIf="emailSent">
        Email inviata, controlla la posta in arrivo e conferma il tuo indirizzo.
      </p>
    </div>
  </div>
</div>

<!-- Error message -->
<ng-container *ngIf="!couponCheckLoading && emailVerified && meError">
  <div class="container profilo">
    <div
      class="d-flex flex-sm-row flex-column-reverse justify-content-between align-items-center my-5"
    >
      <app-user-info [fetchMe]="true" [size]="'medium'"></app-user-info>
    </div>

    <div class="text-center">
      <mat-icon class="warning">warning</mat-icon>
    </div>
    <div class="d-flex justify-content-center">
      <h1 class="text-center my-4">
        <strong>
          Si è verificato un errore. <br />
          Per favore riprova più tardi.
        </strong>
      </h1>
    </div>
  </div>
</ng-container>

<ng-container
  *ngIf="
    (!couponCheckLoading &&
      emailVerified &&
      !meError &&
      accountType !== 'FREE') ||
    (!couponCheckLoading &&
      emailVerified &&
      !meError &&
      coupons &&
      coupons.length > 0)
  "
>
  <svg xmlns="http://www.w3.org/2000/svg" style="display: none">
    <symbol id="check-circle-fill" fill="currentColor" viewBox="0 0 16 16">
      <path
        d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z"
      />
    </symbol>
    <symbol id="info-fill" fill="currentColor" viewBox="0 0 16 16">
      <path
        d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm.93-9.412-1 4.705c-.07.34.029.533.304.533.194 0 .487-.07.686-.246l-.088.416c-.287.346-.92.598-1.465.598-.703 0-1.002-.422-.808-1.319l.738-3.468c.064-.293.006-.399-.287-.47l-.451-.081.082-.381 2.29-.287zM8 5.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2z"
      />
    </symbol>
    <symbol
      id="exclamation-triangle-fill"
      fill="currentColor"
      viewBox="0 0 16 16"
    >
      <path
        d="M8.982 1.566a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566zM8 5c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 0 0 1 8 5zm.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2z"
      />
    </symbol>
  </svg>

  <div class="container profilo">
    <div
      class="d-flex flex-sm-row flex-column-reverse justify-content-between align-items-center my-5"
    >
      <!-- <div>
        <button
          class="do3-secondary-btn lightBlue w-auto d-flex align-items-center cust"
          (click)="toPrenotazione()"
        >
          <span class="material-icons-outlined">add</span>
          NUOVO VIDEOCONSULTO
        </button>
      </div> -->
      <app-user-info [fetchMe]="true" [size]="'medium'"></app-user-info>
    </div>

    <div class="row flex-nowrap">
      <div class="col fixed" id="colfixed">
        <ul class="list-profilo">
          <!-- <li
            [ngClass]="{ active: activeTab == 'home' }"
            (click)="currentTab('homeTab')"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="27.084"
              height="22.64"
              viewBox="0 0 27.084 22.64"
            >
              <path
                id="Icon_ionic-md-home"
                data-name="Icon ionic-md-home"
                d="M11.825,24.779v-6.76h5.07v6.76h5.154V14.639h3.3L14.359,4.5,3.375,14.639h3.3V24.779Z"
                transform="translate(-0.817 -3.139)"
                fill="#2F2F2F"
                stroke="none"
                stroke-width="2"
              />
            </svg>
            Home
          </li> -->

          <li
            [ngClass]="{ active: activeTab == 'richieste' }"
            (click)="currentTab('richiesteTab')"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="19.433"
              height="14.234"
              viewBox="0 0 19.433 14.234"
            >
              <g
                id="_x37_7_Essential_Icons"
                transform="translate(-5.094 -6.757)"
              >
                <g id="List" transform="translate(-12 -12)" fill="#2f2f2f">
                  <path
                    d="M 35.08186721801758 32.74114990234375 L 24.4946460723877 32.74114990234375 C 23.83555603027344 32.74114990234375 23.29935646057129 32.20494842529297 23.29935646057129 31.54586982727051 C 23.29935646057129 30.88678932189941 23.83555603027344 30.35058975219727 24.4946460723877 30.35058975219727 L 35.08186721801758 30.35058975219727 C 35.74094772338867 30.35058975219727 36.27714538574219 30.88678932189941 36.27714538574219 31.54586982727051 C 36.27714538574219 32.20494842529297 35.74094772338867 32.74114990234375 35.08186721801758 32.74114990234375 Z M 20.33537673950195 32.74114990234375 L 18.53933715820312 32.74114990234375 C 17.88024711608887 32.74114990234375 17.34404563903809 32.20494842529297 17.34404563903809 31.54586982727051 C 17.34404563903809 30.88678932189941 17.88024711608887 30.35058975219727 18.53933715820312 30.35058975219727 L 20.33537673950195 30.35058975219727 C 20.99446678161621 30.35058975219727 21.53066635131836 30.88678932189941 21.53066635131836 31.54586982727051 C 21.53066635131836 32.20494842529297 20.99446678161621 32.74114990234375 20.33537673950195 32.74114990234375 Z M 35.08186721801758 27.06943893432617 L 24.4946460723877 27.06943893432617 C 23.83555603027344 27.06943893432617 23.29935646057129 26.53323936462402 23.29935646057129 25.87414932250977 C 23.29935646057129 25.21505928039551 23.83555603027344 24.67885971069336 24.4946460723877 24.67885971069336 L 35.08186721801758 24.67885971069336 C 35.55368804931641 24.67885971069336 35.72179794311523 25.29630851745605 35.72179794311523 25.87414932250977 C 35.72179794311523 26.45199012756348 35.55368804931641 27.06943893432617 35.08186721801758 27.06943893432617 Z M 20.33537673950195 27.06943893432617 L 18.53933715820312 27.06943893432617 C 17.88024711608887 27.06943893432617 17.34404563903809 26.53323936462402 17.34404563903809 25.87414932250977 C 17.34404563903809 25.21505928039551 17.88024711608887 24.67885971069336 18.53933715820312 24.67885971069336 L 20.33537673950195 24.67885971069336 C 20.99446678161621 24.67885971069336 21.53066635131836 25.21505928039551 21.53066635131836 25.87414932250977 C 21.53066635131836 26.53323936462402 20.99446678161621 27.06943893432617 20.33537673950195 27.06943893432617 Z M 35.08186721801758 21.39771842956543 L 24.4946460723877 21.39771842956543 C 23.83555603027344 21.39771842956543 23.29935646057129 20.86151885986328 23.29935646057129 20.20242881774902 C 23.29935646057129 19.54335021972656 23.83555603027344 19.00714874267578 24.4946460723877 19.00714874267578 L 35.08186721801758 19.00714874267578 C 35.74094772338867 19.00714874267578 36.27714538574219 19.54335021972656 36.27714538574219 20.20242881774902 C 36.27714538574219 20.86151885986328 35.74094772338867 21.39771842956543 35.08186721801758 21.39771842956543 Z M 20.33537673950195 21.39771842956543 L 18.53933715820312 21.39771842956543 C 17.88024711608887 21.39771842956543 17.34404563903809 20.86151885986328 17.34404563903809 20.20242881774902 C 17.34404563903809 19.54335021972656 17.88024711608887 19.00714874267578 18.53933715820312 19.00714874267578 L 20.33537673950195 19.00714874267578 C 20.99446678161621 19.00714874267578 21.53066635131836 19.54335021972656 21.53066635131836 20.20242881774902 C 21.53066635131836 20.86151885986328 20.99446678161621 21.39771842956543 20.33537673950195 21.39771842956543 Z"
                    stroke="none"
                  />
                  <path
                    d="M 35.08186721801758 32.49114990234375 C 35.60176467895508 32.49114990234375 36.02714538574219 32.06578063964844 36.02714538574219 31.54586982727051 C 36.02714538574219 31.02595901489258 35.60176467895508 30.60058975219727 35.08186721801758 30.60058975219727 L 24.4946460723877 30.60058975219727 C 23.9747371673584 30.60058975219727 23.54935646057129 31.02595901489258 23.54935646057129 31.54586982727051 C 23.54935646057129 32.06578063964844 23.9747371673584 32.49114990234375 24.4946460723877 32.49114990234375 L 35.08186721801758 32.49114990234375 M 20.33537673950195 32.49114990234375 C 20.85528564453125 32.49114990234375 21.28066635131836 32.06578063964844 21.28066635131836 31.54586982727051 C 21.28066635131836 31.02595901489258 20.85528564453125 30.60058975219727 20.33537673950195 30.60058975219727 L 18.53933715820312 30.60058975219727 C 18.0194263458252 30.60058975219727 17.59404563903809 31.02595901489258 17.59404563903809 31.54586982727051 C 17.59404563903809 32.06578063964844 18.0194263458252 32.49114990234375 18.53933715820312 32.49114990234375 L 20.33537673950195 32.49114990234375 M 35.08186721801758 26.81943893432617 C 35.60176467895508 26.81943893432617 35.60176467895508 24.92885971069336 35.08186721801758 24.92885971069336 L 24.4946460723877 24.92885971069336 C 23.9747371673584 24.92885971069336 23.54935646057129 25.35424995422363 23.54935646057129 25.87414932250977 C 23.54935646057129 26.3940601348877 23.9747371673584 26.81943893432617 24.4946460723877 26.81943893432617 L 35.08186721801758 26.81943893432617 M 20.33537673950195 26.81943893432617 C 20.85528564453125 26.81943893432617 21.28066635131836 26.3940601348877 21.28066635131836 25.87414932250977 C 21.28066635131836 25.35424995422363 20.85528564453125 24.92885971069336 20.33537673950195 24.92885971069336 L 18.53933715820312 24.92885971069336 C 18.0194263458252 24.92885971069336 17.59404563903809 25.35424995422363 17.59404563903809 25.87414932250977 C 17.59404563903809 26.3940601348877 18.0194263458252 26.81943893432617 18.53933715820312 26.81943893432617 L 20.33537673950195 26.81943893432617 M 35.08186721801758 21.14771842956543 C 35.60176467895508 21.14771842956543 36.02714538574219 20.72233963012695 36.02714538574219 20.20242881774902 C 36.02714538574219 19.68251991271973 35.60176467895508 19.25714874267578 35.08186721801758 19.25714874267578 L 24.4946460723877 19.25714874267578 C 23.9747371673584 19.25714874267578 23.54935646057129 19.68251991271973 23.54935646057129 20.20242881774902 C 23.54935646057129 20.72233963012695 23.9747371673584 21.14771842956543 24.4946460723877 21.14771842956543 L 35.08186721801758 21.14771842956543 M 20.33537673950195 21.14771842956543 C 20.85528564453125 21.14771842956543 21.28066635131836 20.72233963012695 21.28066635131836 20.20242881774902 C 21.28066635131836 19.68251991271973 20.85528564453125 19.25714874267578 20.33537673950195 19.25714874267578 L 18.53933715820312 19.25714874267578 C 18.0194263458252 19.25714874267578 17.59404563903809 19.68251991271973 17.59404563903809 20.20242881774902 C 17.59404563903809 20.72233963012695 18.0194263458252 21.14771842956543 18.53933715820312 21.14771842956543 L 20.33537673950195 21.14771842956543 M 35.08186721801758 32.99114990234375 L 24.4946460723877 32.99114990234375 C 23.69770622253418 32.99114990234375 23.04935646057129 32.34280014038086 23.04935646057129 31.54586982727051 C 23.04935646057129 30.74893951416016 23.69770622253418 30.10058975219727 24.4946460723877 30.10058975219727 L 35.08186721801758 30.10058975219727 C 35.8787956237793 30.10058975219727 36.52714538574219 30.74893951416016 36.52714538574219 31.54586982727051 C 36.52714538574219 32.34280014038086 35.8787956237793 32.99114990234375 35.08186721801758 32.99114990234375 Z M 20.33537673950195 32.99114990234375 L 18.53933715820312 32.99114990234375 C 17.74239730834961 32.99114990234375 17.09404563903809 32.34280014038086 17.09404563903809 31.54586982727051 C 17.09404563903809 30.74893951416016 17.74239730834961 30.10058975219727 18.53933715820312 30.10058975219727 L 20.33537673950195 30.10058975219727 C 21.13231658935547 30.10058975219727 21.78066635131836 30.74893951416016 21.78066635131836 31.54586982727051 C 21.78066635131836 32.34280014038086 21.13231658935547 32.99114990234375 20.33537673950195 32.99114990234375 Z M 35.08186721801758 27.31943893432617 L 24.4946460723877 27.31943893432617 C 23.69770622253418 27.31943893432617 23.04935646057129 26.67108917236328 23.04935646057129 25.87414932250977 C 23.04935646057129 25.07720947265625 23.69770622253418 24.42885971069336 24.4946460723877 24.42885971069336 L 35.08186721801758 24.42885971069336 C 35.63079833984375 24.42885971069336 35.97179794311523 24.98265838623047 35.97179794311523 25.87414932250977 C 35.97179794311523 26.76564025878906 35.63079833984375 27.31943893432617 35.08186721801758 27.31943893432617 Z M 20.33537673950195 27.31943893432617 L 18.53933715820312 27.31943893432617 C 17.74239730834961 27.31943893432617 17.09404563903809 26.67108917236328 17.09404563903809 25.87414932250977 C 17.09404563903809 25.07720947265625 17.74239730834961 24.42885971069336 18.53933715820312 24.42885971069336 L 20.33537673950195 24.42885971069336 C 21.13231658935547 24.42885971069336 21.78066635131836 25.07720947265625 21.78066635131836 25.87414932250977 C 21.78066635131836 26.67108917236328 21.13231658935547 27.31943893432617 20.33537673950195 27.31943893432617 Z M 35.08186721801758 21.64771842956543 L 24.4946460723877 21.64771842956543 C 23.69770622253418 21.64771842956543 23.04935646057129 20.99936866760254 23.04935646057129 20.20242881774902 C 23.04935646057129 19.40549850463867 23.69770622253418 18.75714874267578 24.4946460723877 18.75714874267578 L 35.08186721801758 18.75714874267578 C 35.8787956237793 18.75714874267578 36.52714538574219 19.40549850463867 36.52714538574219 20.20242881774902 C 36.52714538574219 20.99936866760254 35.8787956237793 21.64771842956543 35.08186721801758 21.64771842956543 Z M 20.33537673950195 21.64771842956543 L 18.53933715820312 21.64771842956543 C 17.74239730834961 21.64771842956543 17.09404563903809 20.99936866760254 17.09404563903809 20.20242881774902 C 17.09404563903809 19.40549850463867 17.74239730834961 18.75714874267578 18.53933715820312 18.75714874267578 L 20.33537673950195 18.75714874267578 C 21.13231658935547 18.75714874267578 21.78066635131836 19.40549850463867 21.78066635131836 20.20242881774902 C 21.78066635131836 20.99936866760254 21.13231658935547 21.64771842956543 20.33537673950195 21.64771842956543 Z"
                    stroke="none"
                    fill="#2f2f2f"
                  />
                </g>
              </g>
            </svg>
            Appuntamenti
          </li>

          <!-- <li
            [ngClass]="{ active: activeTab == 'info' }"
            (click)="currentTab('infoTab')"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="22.981"
              height="23"
              viewBox="0 0 22.981 23"
            >
              <path
                id="Tracciato_492"
                data-name="Tracciato 492"
                d="M13.509,2A11.512,11.512,0,0,0,5.048,21.294h0a11.512,11.512,0,0,0,16.923,0h0A11.512,11.512,0,0,0,13.509,2Zm0,20.722a9.21,9.21,0,0,1-6.389-2.59,6.907,6.907,0,0,1,12.778,0A9.21,9.21,0,0,1,13.509,22.722Zm-2.3-11.512a2.3,2.3,0,1,1,2.3,2.3A2.3,2.3,0,0,1,11.207,11.21Zm10.257,6.907a9.21,9.21,0,0,0-4.5-3.891,4.6,4.6,0,1,0-6.907,0,9.21,9.21,0,0,0-4.5,3.891,9.117,9.117,0,0,1-1.255-4.6,9.21,9.21,0,1,1,18.419,0A9.118,9.118,0,0,1,21.464,18.117Z"
                transform="translate(-2.019 -2)"
                fill="#2F2F2F"
              />
            </svg>
            Profilo
          </li> -->

          <!-- <li
            [ngClass]="{ active: activeTab == 'cronologia' }"
            (click)="currentTab('cronologiaTab')"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="23.251"
              viewBox="0 0 24 23.251"
            >
              <g
                id="Raggruppa_18638"
                data-name="Raggruppa 18638"
                transform="translate(-386 -459)"
              >
                <g id="Raggruppa_18637" data-name="Raggruppa 18637">
                  <path
                    id="Tracciato_1793"
                    data-name="Tracciato 1793"
                    d="M28.119,58.894H19.175a.353.353,0,0,1-.355-.355,2.248,2.248,0,0,1,2.245-2.249h5.171a2.248,2.248,0,0,1,2.245,2.245A.37.37,0,0,1,28.119,58.894Z"
                    transform="translate(374.68 423.107)"
                    fill="#2F2F2F"
                    stroke="#2F2F2F"
                    stroke-width="0.5"
                  />
                  <path
                    id="Tracciato_1795"
                    data-name="Tracciato 1795"
                    d="M27.959,21.616H18.575a.353.353,0,0,1-.355-.355,5.047,5.047,0,0,1,10.094,0A.353.353,0,0,1,27.959,21.616Zm-9.013-.711h8.644a4.336,4.336,0,0,0-8.644,0Zm4.322-5.578a2.469,2.469,0,1,1,2.469-2.469A2.472,2.472,0,0,1,23.267,15.327Zm0-4.227a1.758,1.758,0,1,0,1.758,1.758A1.761,1.761,0,0,0,23.267,11.1Z"
                    transform="translate(374.848 452.196)"
                    fill="#2F2F2F"
                    stroke="#2F2F2F"
                    stroke-width="0.5"
                  />
                  <g
                    id="Rettangolo_8977"
                    data-name="Rettangolo 8977"
                    transform="translate(386 459)"
                    fill="none"
                    stroke-width="2"
                  >
                    <rect width="24" height="19" rx="3" stroke="none" />
                    <rect
                      x="1"
                      y="1"
                      width="22"
                      height="17"
                      rx="2"
                      fill="none"
                    />
                  </g>
                </g>
              </g>
            </svg>
            Cronologia
          </li> -->
          <!-- <li
            [ngClass]="{ active: activeTab == 'anamnesi' }"
            (click)="currentTab('anamnesiTab')"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20.284"
              height="23.351"
              viewBox="0 0 20.284 23.351"
            >
              <g
                id="Raggruppa_18642"
                data-name="Raggruppa 18642"
                transform="translate(-387.858 -532.825)"
              >
                <g id="Raggruppa_18641" data-name="Raggruppa 18641">
                  <g id="checklist" transform="translate(385.033 532)">
                    <path
                      id="Tracciato_84987"
                      data-name="Tracciato 84987"
                      d="M20.966,2.533h-3.4V1.767A.767.767,0,0,0,16.8,1H9.133a.767.767,0,0,0-.767.767v.767h-3.4A1.97,1.97,0,0,0,3,4.5V22.033A1.97,1.97,0,0,0,4.967,24h16a1.97,1.97,0,0,0,1.967-1.967V4.5a1.97,1.97,0,0,0-1.967-1.967ZM9.9,2.533h6.133V4.067H9.9Zm11.5,19.5a.435.435,0,0,1-.434.434h-16a.435.435,0,0,1-.434-.434V4.5a.435.435,0,0,1,.434-.434h3.4v.767a.767.767,0,0,0,.767.767H16.8a.767.767,0,0,0,.767-.767V4.067h3.4A.435.435,0,0,1,21.4,4.5Z"
                      fill="#2F2F2F"
                    />
                    <path
                      id="Tracciato_84987_-_Contorno"
                      data-name="Tracciato 84987 - Contorno"
                      d="M9.133.825H16.8a.943.943,0,0,1,.942.942v.592h3.224A2.148,2.148,0,0,1,23.109,4.5V22.033a2.148,2.148,0,0,1-2.142,2.142h-16a2.148,2.148,0,0,1-2.142-2.142V4.5A2.148,2.148,0,0,1,4.967,2.358H8.192V1.767A.943.943,0,0,1,9.133.825Zm11.833,23a1.8,1.8,0,0,0,1.792-1.793V4.5a1.8,1.8,0,0,0-1.793-1.792H17.392V1.767a.592.592,0,0,0-.592-.592H9.133a.592.592,0,0,0-.592.592v.942H4.967A1.8,1.8,0,0,0,3.175,4.5V22.033a1.8,1.8,0,0,0,1.793,1.792ZM9.725,2.358h6.483V4.242H9.725Zm6.133.35H10.075V3.892h5.783ZM4.967,3.892H8.542v.942a.592.592,0,0,0,.592.592H16.8a.592.592,0,0,0,.592-.592V3.892h3.574a.611.611,0,0,1,.609.609V22.033a.611.611,0,0,1-.609.609h-16a.611.611,0,0,1-.609-.609V4.5A.611.611,0,0,1,4.967,3.892Zm3.225.35H4.967a.26.26,0,0,0-.259.259V22.033a.26.26,0,0,0,.259.259h16a.26.26,0,0,0,.259-.259V4.5a.26.26,0,0,0-.259-.259H17.742v.592a.943.943,0,0,1-.942.942H9.133a.943.943,0,0,1-.942-.942Z"
                      fill="#2F2F2F"
                    />
                    <path
                      id="Tracciato_84988"
                      data-name="Tracciato 84988"
                      d="M11.058,9.225,9.3,10.983l-.991-.991a.767.767,0,1,0-1.084,1.084l1.533,1.533a.767.767,0,0,0,1.084,0l2.3-2.3a.767.767,0,1,0-1.084-1.084Z"
                      transform="translate(-0.933 -1.867)"
                      fill="#2F2F2F"
                    />
                    <path
                      id="Tracciato_84988_-_Contorno"
                      data-name="Tracciato 84988 - Contorno"
                      d="M11.6,8.825a.942.942,0,0,1,.666,1.608l-2.3,2.3a.942.942,0,0,1-1.332,0L7.1,11.2A.942.942,0,1,1,8.433,9.868l.868.868,1.5-1.5h0l.131-.131A.936.936,0,0,1,11.6,8.825ZM9.3,12.658a.588.588,0,0,0,.418-.173l2.3-2.3a.592.592,0,0,0-.828-.845L9.3,11.23,8.185,10.115a.592.592,0,1,0-.837.837l1.533,1.533A.588.588,0,0,0,9.3,12.658Z"
                      transform="translate(-0.933 -1.867)"
                      fill="#2F2F2F"
                    />
                    <path
                      id="Tracciato_84989"
                      data-name="Tracciato 84989"
                      d="M22.133,11H16.767a.767.767,0,0,0,0,1.533h5.367a.767.767,0,1,0,0-1.533Z"
                      transform="translate(-3.033 -2.333)"
                      fill="#2F2F2F"
                    />
                    <path
                      id="Tracciato_84989_-_Contorno"
                      data-name="Tracciato 84989 - Contorno"
                      d="M16.767,10.825h5.367a.942.942,0,0,1,0,1.883H16.767a.942.942,0,0,1,0-1.883Zm5.367,1.533a.592.592,0,0,0,0-1.183H16.767a.592.592,0,0,0,0,1.183Z"
                      transform="translate(-3.033 -2.333)"
                      fill="#2F2F2F"
                    />
                    <path
                      id="Tracciato_84990"
                      data-name="Tracciato 84990"
                      d="M11.058,15.225,9.3,16.983l-.991-.991a.767.767,0,1,0-1.084,1.084l1.533,1.533a.767.767,0,0,0,1.084,0l2.3-2.3a.767.767,0,1,0-1.084-1.084Z"
                      transform="translate(-0.933 -3.266)"
                      fill="#2F2F2F"
                    />
                    <path
                      id="Tracciato_84990_-_Contorno"
                      data-name="Tracciato 84990 - Contorno"
                      d="M11.6,14.825a.942.942,0,0,1,.666,1.608l-2.3,2.3a.942.942,0,0,1-1.332,0L7.1,17.2a.942.942,0,1,1,1.332-1.332l.868.868,1.5-1.5h0l.131-.131A.936.936,0,0,1,11.6,14.825ZM9.3,18.658a.588.588,0,0,0,.418-.173l2.3-2.3a.592.592,0,0,0-.828-.845L9.3,17.23,8.185,16.115a.592.592,0,1,0-.837.837l1.533,1.533A.588.588,0,0,0,9.3,18.658Z"
                      transform="translate(-0.933 -3.266)"
                      fill="#2F2F2F"
                    />
                    <path
                      id="Tracciato_84991"
                      data-name="Tracciato 84991"
                      d="M22.133,17H16.767a.767.767,0,0,0,0,1.533h5.367a.767.767,0,1,0,0-1.533Z"
                      transform="translate(-3.033 -3.733)"
                      fill="#2F2F2F"
                    />
                    <path
                      id="Tracciato_84991_-_Contorno"
                      data-name="Tracciato 84991 - Contorno"
                      d="M16.767,16.825h5.367a.942.942,0,0,1,0,1.883H16.767a.942.942,0,0,1,0-1.883Zm5.367,1.533a.592.592,0,0,0,0-1.183H16.767a.592.592,0,0,0,0,1.183Z"
                      transform="translate(-3.033 -3.733)"
                      fill="#2F2F2F"
                    />
                    <path
                      id="Tracciato_84992"
                      data-name="Tracciato 84992"
                      d="M11.058,21.225,9.3,22.983l-.991-.991a.767.767,0,1,0-1.084,1.084l1.533,1.533a.767.767,0,0,0,1.084,0l2.3-2.3a.767.767,0,1,0-1.084-1.084Z"
                      transform="translate(-0.933 -4.666)"
                      fill="#2F2F2F"
                    />
                    <path
                      id="Tracciato_84992_-_Contorno"
                      data-name="Tracciato 84992 - Contorno"
                      d="M11.6,20.825a.942.942,0,0,1,.666,1.608l-2.3,2.3a.942.942,0,0,1-1.332,0L7.1,23.2a.942.942,0,1,1,1.332-1.332l.868.868,1.5-1.5h0l.131-.131A.936.936,0,0,1,11.6,20.825ZM9.3,24.658a.588.588,0,0,0,.418-.173l2.3-2.3a.592.592,0,0,0-.828-.845L9.3,23.23,8.185,22.115a.592.592,0,1,0-.837.837l1.533,1.533A.588.588,0,0,0,9.3,24.658Z"
                      transform="translate(-0.933 -4.666)"
                      fill="#2F2F2F"
                    />
                    <path
                      id="Tracciato_84993"
                      data-name="Tracciato 84993"
                      d="M22.133,23H16.767a.767.767,0,0,0,0,1.533h5.367a.767.767,0,1,0,0-1.533Z"
                      transform="translate(-3.033 -5.133)"
                      fill="#2F2F2F"
                    />
                    <path
                      id="Tracciato_84993_-_Contorno"
                      data-name="Tracciato 84993 - Contorno"
                      d="M16.767,22.825h5.367a.942.942,0,0,1,0,1.883H16.767a.942.942,0,0,1,0-1.883Zm5.367,1.533a.592.592,0,0,0,0-1.183H16.767a.592.592,0,0,0,0,1.183Z"
                      transform="translate(-3.033 -5.133)"
                      fill="#2F2F2F"
                    />
                  </g>
                </g>
              </g>
            </svg>
            Questionari
          </li> -->

          <!--<li [ngClass]="{ active: activeTab == 'movergy' }" (click)="currentTab('movergy')">-->
          <!-- <li [ngClass]="{ active: activeTab == 'movergy' }" class="myhealth">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24.747"
              height="18.255"
              viewBox="0 0 24.747 18.255"
            >
              <g
                id="Raggruppa_3830"
                data-name="Raggruppa 3830"
                transform="translate(-339.086 -592.448)"
              >
                <path
                  id="Tracciato_7067"
                  data-name="Tracciato 7067"
                  d="M125.364,209.124l.586-1.015a.248.248,0,1,1,.43.248l-.586,1.015a.248.248,0,0,1-.43-.248Zm-3.728-2.038a.248.248,0,1,1,.5,0v1.172a.248.248,0,1,1-.5,0ZM114.5,215.9h-1.172a.248.248,0,1,1,0-.5H114.5a.248.248,0,1,1,0,.5Zm1.2-3.819a.248.248,0,0,1-.339.091l-1.015-.586a.248.248,0,1,1,.248-.43l1.015.586A.248.248,0,0,1,115.7,212.077Zm2.614-2.614a.248.248,0,0,1-.339-.091l-.586-1.015a.248.248,0,1,1,.43-.248l.586,1.015A.248.248,0,0,1,118.314,209.463Zm9.327.659-4.069,7.717a1.772,1.772,0,1,1-1.744-1.231l5.4-6.756a.247.247,0,0,1,.412.271Zm.427,1.955a.248.248,0,0,1,.091-.339l1.015-.586a.248.248,0,1,1,.248.43l-1.015.586A.248.248,0,0,1,128.068,212.077Zm2.377,3.819h-1.172a.248.248,0,1,1,0-.5h1.172a.248.248,0,1,1,0,.5Z"
                  transform="translate(229.575 389.26)"
                  fill="#2F2F2F"
                  stroke="#2F2F2F"
                  stroke-width="1"
                />
                <path
                  id="Tracciato_7066"
                  data-name="Tracciato 7066"
                  d="M66.073,172.992a10.632,10.632,0,1,1,18.322,0h1.422a11.874,11.874,0,1,0-21.167,0Z"
                  transform="translate(276.225 437.211)"
                  fill="#2F2F2F"
                  stroke="#2F2F2F"
                  stroke-width="1"
                />
              </g>
            </svg>
            MyHealth
          </li> -->
          <!-- <li
            [ngClass]="{ active: activeTab == 'documenti' }"
            (click)="currentTab('documentiTab')"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="19.217"
              height="23.896"
              viewBox="0 0 19.217 23.896"
            >
              <path
                id="Tracciato_1796"
                data-name="Tracciato 1796"
                d="M9.849,11.359h1.17a1.17,1.17,0,1,0,0-2.34H9.849a1.17,1.17,0,1,0,0,2.34Zm0,2.34a1.17,1.17,0,1,0,0,2.34h7.019a1.17,1.17,0,1,0,0-2.34Zm12.868-3.58a1.532,1.532,0,0,0-.07-.316V9.7a1.252,1.252,0,0,0-.222-.328h0L15.406,2.351h0a1.252,1.252,0,0,0-.328-.222.374.374,0,0,0-.105,0A1.029,1.029,0,0,0,14.587,2H7.509A3.509,3.509,0,0,0,4,5.509V21.887A3.509,3.509,0,0,0,7.509,25.4h11.7a3.509,3.509,0,0,0,3.509-3.509V10.119ZM15.7,5.989l3.03,3.03h-1.86a1.17,1.17,0,0,1-1.17-1.17Zm4.679,15.9a1.17,1.17,0,0,1-1.17,1.17H7.509a1.17,1.17,0,0,1-1.17-1.17V5.509a1.17,1.17,0,0,1,1.17-1.17h5.849V7.849a3.509,3.509,0,0,0,3.509,3.509h3.509Zm-3.509-3.509H9.849a1.17,1.17,0,0,0,0,2.34h7.019a1.17,1.17,0,0,0,0-2.34Z"
                transform="translate(-3.75 -1.75)"
                fill="#2F2F2F"
                stroke-width="0.5"
              />
            </svg>
            Documenti
          </li> -->

          <!-- <li
            class="pagamento"
            [ngClass]="{ active: activeTab == 'fatturazione' }"
            (click)="currentTab('fatturazioneTab')"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="23"
              height="16.429"
              viewBox="0 0 23 16.429"
            >
              <g
                id="Raggruppa_1378"
                data-name="Raggruppa 1378"
                transform="translate(-2 -6)"
              >
                <path
                  id="Tracciato_1797"
                  data-name="Tracciato 1797"
                  d="M22.536,6H4.464A2.464,2.464,0,0,0,2,8.464v11.5a2.464,2.464,0,0,0,2.464,2.464H22.536A2.464,2.464,0,0,0,25,19.964V8.464A2.464,2.464,0,0,0,22.536,6ZM4.464,7.643H22.536a.821.821,0,0,1,.821.821v1.643H3.643V8.464A.821.821,0,0,1,4.464,7.643ZM22.536,20.786H4.464a.821.821,0,0,1-.821-.821V13.393H23.357v6.571A.821.821,0,0,1,22.536,20.786Z"
                  transform="translate(0)"
                  fill="#2F2F2F"
                />
                <rect
                  id="Rettangolo_440"
                  data-name="Rettangolo 440"
                  width="7"
                  height="2"
                  transform="translate(14 18.429)"
                  fill="#2F2F2F"
                />
              </g>
            </svg>
            Pagamenti
            <div
              *ngIf="ordersToPay && ordersToPay.length > 0"
              class="red-dot"
              [ngClass]="{ 'reverse-dot': activeTab == 'fatturazione' }"
            >
              {{ ordersToPay.length }}
            </div>
          </li> -->

          <!-- <li
            [ngClass]="{ active: activeTab == 'privacy' }"
            (click)="currentTab('privacyTab')"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="19.197"
              height="27.425"
              viewBox="0 0 19.197 27.425"
            >
              <g
                id="Raggruppa_1486"
                data-name="Raggruppa 1486"
                transform="translate(-5 -2)"
              >
                <path
                  id="Tracciato_1832"
                  data-name="Tracciato 1832"
                  d="M22.826,10.227H21.455V8.856a6.856,6.856,0,1,0-13.712,0v1.371H6.371A1.371,1.371,0,0,0,5,11.6V22.245a4.093,4.093,0,0,0,2.273,3.68l6.712,3.355a1.371,1.371,0,0,0,1.227,0l6.712-3.355a4.093,4.093,0,0,0,2.272-3.68V11.6A1.371,1.371,0,0,0,22.826,10.227ZM10.485,8.856a4.114,4.114,0,1,1,8.227,0v1.371H10.485Zm10.97,13.389a1.363,1.363,0,0,1-.758,1.227L14.6,26.52,8.5,23.47a1.363,1.363,0,0,1-.758-1.226V12.97H21.455Z"
                  transform="translate(0 0)"
                  fill="#2F2F2F"
                />
                <path
                  id="Tracciato_1833"
                  data-name="Tracciato 1833"
                  d="M12.371,12A1.371,1.371,0,0,0,11,13.371v2.742a1.371,1.371,0,0,0,2.742,0V13.371A1.371,1.371,0,0,0,12.371,12Z"
                  transform="translate(2.227 3.712)"
                  fill="#2F2F2F"
                />
              </g>
            </svg>
            Privacy
          </li> -->
        </ul>
      </div>

      <div class="col m-0">
        <ng-container [ngSwitch]="currentStep$ | async">
          <app-dashboard
            (doctype)="onNewDoc($event)"
            (changeStep)="receiveStep($event)"
            *ngSwitchCase="'home'"
          ></app-dashboard>
          <app-richieste *ngSwitchCase="'richieste'"></app-richieste>
          <!-- <app-info-profilo *ngSwitchCase="'info'"></app-info-profilo> -->
          <!-- <app-cronologia *ngSwitchCase="'cronologia'"></app-cronologia> -->
          <app-documenti
            [docType]="docType"
            *ngSwitchCase="'documenti'"
          ></app-documenti>
          <!-- <app-fatturazione *ngSwitchCase="'fatturazione'"></app-fatturazione> -->
          <!-- <app-anamnesi *ngSwitchCase="'anamnesi'"></app-anamnesi> -->
          <!-- <app-privacy *ngSwitchCase="'privacy'"></app-privacy> -->
          <!-- <app-movergy-page *ngSwitchCase="'movergy'"></app-movergy-page> -->
        </ng-container>
      </div>
    </div>
  </div>

  <app-chatta-hm></app-chatta-hm>
  <!-- <app-get-stream></app-get-stream> -->
</ng-container>

<ng-container
  *ngIf="
    !couponCheckLoading &&
    emailVerified &&
    coupons &&
    coupons.length == 0 &&
    accountType === 'FREE'
  "
>
  <div class="coupons container-fluid fullscreen-message">
    <!-- <h1 class="display-4">Arriveremo presto!</h1>
    <p class="lead">
      Non preoccuparti, ti avviseremo quando DrFeel sarà disponibile per te!
    </p> -->
    <ng-container *ngIf="authError">
      <p class="lead"><strong>Errore:</strong> {{ authError }}</p>
    </ng-container>
    <ng-container *ngIf="couponError">
      <div class="text-center">
        <mat-icon class="warning">warning</mat-icon>
      </div>
      <div class="d-flex justify-content-center">
        <h1 class="text-center my-4">
          <p class="warning">
            {{ couponErrorMessage }}
          </p>
        </h1>
      </div>
    </ng-container>
    <h1 class="text-gradient-drfeel">Inserisci il tuo codice!</h1>
    <p>
      Inserisci il codice che hai ricevuto via email per registrarti al
      servizio.
    </p>

    <input
      type="coupon"
      #coupon="ngModel"
      ngModel
      name="coupon"
      aria-describedby="couponHelp"
      id="coupon"
      placeholder="Codice"
      [(ngModel)]="couponCode"
    />
    <button
      class="coupon-input do3-secondary-btn lightBlue w-auto d-flex align-items-center cust"
      (click)="postCoupon()"
    >
      Verifica
    </button>
  </div>
</ng-container>
